import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AutorunComponent } from '@myshared/autorun.component';
import { Company } from '../../company/company.model';
import { PortOrderDraft } from '../../sessionkv/sessionkv-port-order';

@Component({
    selector: 'app-order-draft-card',
    templateUrl: './order-draft-card.component.html',
    standalone: false
})
export class OrderDraftCardComponent extends AutorunComponent {
    @Input() draft: PortOrderDraft;
    @Input() instancename: string;
    @Input() showCreate: boolean = true;
    @Input() showDelete: boolean = true;
    @Input() contactName: string;

    @Output() delete = new EventEmitter<PortOrderDraft>();
    @Output() continue = new EventEmitter<PortOrderDraft>();

    constructor() {
        super();
    }

    public get isPhoneBillStep() {
        return !this.draft.portOrder.losingProviderPhoneBill;
    }

    public canSaveDraft(draft: PortOrderDraft): boolean {
        return !draft.portOrder.losingProviderPhoneBill?.assetKey;
    }

    public get blockNumber(): {numberFrom: string, numberEnd: string} {
        if (this.draft.portOrder.numberBlocks.$case === 'numberBlock') {
            const numberBlocks = this.draft.portOrder.numberBlocks.numberBlock;
            const number = numberBlocks.countryPrefix+numberBlocks.areaCode+numberBlocks.mainNumber

            return {
                numberFrom: number+numberBlocks.blockStart,
                numberEnd: number+numberBlocks.blockEnd
            }
        }

        return {
            numberFrom: '',
            numberEnd: ''
        }
    }

    public get phoneNumbers(): string[] {
        if (this.draft.portOrder.numberBlocks.$case === 'singleNumbers') {
            const numbers = this.draft.portOrder.numberBlocks.singleNumbers;
            return numbers.phoneNumbers.map(phone => {
                return phone.countryPrefix+phone.areaCode+phone.number;
            }) || [];
        }

        return [];
    }

    onDelete() {
        if (this.draft) {
            this.delete.emit(this.draft);
        }
    }

    onContinue() {
        if (this.draft) {
            this.continue.emit(this.draft);
        }
    }

    public get isBlock(){
        return this.draft.portOrder.numberBlocks.$case === "numberBlock"; 
    }

}
